import { ChangeEvent } from 'react'

const setInputValues = (event: ChangeEvent<HTMLInputElement>, state: object | string, updateState: Function) => {

    if (typeof state === 'string') {
        updateState(event.target.value)
    }
    
    /** Keep the state key name and input name same */
    if (typeof state === 'object') {
        updateState({...state, [event.target.name]: event.target.value})
    }
    
}

export default setInputValues